import React from "react";
import style from "../modal-content/ModalContent.module.scss";

export const ModalImage = ({image}) => {
  return <img src={image} className={style.imgBody} alt="imgBody" />;
};
